export default "{\n    \"viewJob\": \"VIEW JOB\"\n}\n"